export default "__VITE_ASSET__11adf693__"